import {hel_DispatchEvent} from '../../logics/moduleCaller';

import {CTextChatApiNotification} from './CTextChatApiNotification';

import type {JsonObject} from '../../../../HeliportJS/dist/models/json';

export class CTextChat {
  m_TextChatApiNotification: CTextChatApiNotification | null = null;

  // コンストラクタ
  constructor() {
    this.m_TextChatApiNotification = new CTextChatApiNotification();
  }

  /** テキストチャット送信処理の起動 */
  addReceivedChatEventListener(fn: (params: JsonObject) => void) {
    this.m_TextChatApiNotification?.addPosChannelEvent(fn);
  }

  /** 個別テキストチャット送信処理の起動 */
  addReceivedPersonalChatEventListener(fn: (params: JsonObject) => void) {
    this.m_TextChatApiNotification?.addPersonalEvent(fn);
  }

  /** システムテキスト送信処理の起動 */
  addReceivedSystemChatEventListener(fn: (params: JsonObject) => void) {
    this.m_TextChatApiNotification?.addSystemEvent(fn);
  }

  /** テキストチャット送信処理の起動 */
  receive(params: JsonObject) {
    hel_DispatchEvent('textchat-receive-text-chat-message', JSON.stringify(params));
  }

  /** 個別テキストチャット送信処理の起動 */
  receivePersonal(params: JsonObject) {
    hel_DispatchEvent('textchat-receive-text-chat-message-personal', JSON.stringify(params));
  }
}
